import { StandaloneArticleFooter, StandaloneArticleFooterProps } from 'base/components/ArticleFooter';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export const AllasStandaloneArticleFooter: typeof StandaloneArticleFooter = (props) => {
  return (
    <StandaloneArticleFooter
      {...mergeProps(
        {
          options: {
            $tags: {
              align: 'center',
            },
          },
        },
        props
      )}
    />
  );
};

export default AllasStandaloneArticleFooter;
